import request from 'utils/header'
import requestv2 from 'utils/realtime'
import authStorage from '../storage'
const dayjs = require('dayjs')
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
const axios = require('axios').default
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Manila')

const authToken = authStorage.getToken()

// const get_users = (_type) =>
//   request
//     .get('/users')
//     .then((users) => {
//       let newUser = []
//       if (!users.data) return newUser

//       users.data.map((v, k) => {
//         if (v.role !== _type) return ''
//         if (v.firstName === null || v.lastName === null) return ''
//         return newUser.push({...v})
//       })

//       return {
//         ok: true,
//         data: newUser,
//       }
//     })
//     .catch((err) => {
//       return {ok: false, data: err}
//     })

const get_user = (_id) => requestv2.get(`/user/${_id}`)

const get_user_status = (_id) => axios.get(`https://api-admin.sparkletimekeeping.com/api/user/status/${_id}`)

const check_user_archived = (_id) => axios.get(`https://api-admin.sparkletimekeeping.com/api/user/${_id}/archived`)

const get_user_archived = (_id) => requestv2.get(`/user/${_id}/archived`)

const create_new_password = () => request.get(`/user/generate/password`)

const validate_password = (_id) => request.get(`/user/validate/password/${_id}`)

const get_limited_users = (_id) => axios.get(`https://api-admin.sparkletimekeeping.com/api/user/limited/records/${_id}`)

const get_limited_usersV2 = () => request.get(`/user/limited/recordsV2`)

const get_limited_usersV3 = (company, search = 'all') => request.post(`/user/limited/recordsV3`, {company, search})

const get_limited_usersV4 = (userId, limit = 5) => request.post(`/user/limited/recordsV4`, {userId, limit})

const get_record_by_id = (_id) => request.get(`/record/${_id}`)

const delete_record_by_id = (_id) => request.get(`/record/delete/${_id}`)

const delete_last_record_by_id = (_id) => request.get(`/record/delete/last/${_id}`)

const delete_demo_last_record = (_id) => request.get(`/record/delete/last/demo/${_id}`)


const update_record_by_id = (_id, _data) => request.patch(`/v2/record/update/${_id}`, _data)

const get_users_bydate = (_id, _date) => request.get(`/user/records/bydate/${_id}/${_date}`)

const get_users = (_id) => request.get(`/store/users/${_id}`)

const get_users_archived = (_id) => request.get(`/store/users/archive/${_id}`)

const archive_user = (store_id, user_id) => request.get(`/store/${store_id}/user/${user_id}/archive`)

const restore_user = (store_id, user_id) => request.get(`/store/${store_id}/user/${user_id}/restore`)

const post_store_register = (_data) => request.post(`/store/register`, _data)

const post_employee_register = (_data) => request.post(`/employee/register`, _data)

const patch_store_onboard = (_data, _id) => request.patch(`/v2/user/store/${_id}`, _data)

const post_user_status = (_status, _location, _id, _previous) => {
  const date = dayjs().tz('Asia/Manila').utc().format()
  return request.post(`/user/time/${_id}`, {status: _status, location: _location, logdate: date, previous: _previous})
}
const post_user_workmate_status = (_status, _location, _id, _previous, _workmate) => {
  const date = dayjs().tz('Asia/Manila').utc().format()
  return request.post(`/user/workmate_time/${_id}`, {
    status: _status,
    location: _location,
    logdate: date,
    previous: _previous,
    workmate: _workmate,
  })
}
const remove_user = (_id, _uid) => request.delete(`/store/${_id}/user/${_uid}`)

const patch_user_onboard = (_data, _id) => request.patch(`/user/${_id}`, _data)

const get_user_records = (_id, limit = null) => {
  if (limit) {
    return axios.get(`https://api-admin.sparkletimekeeping.com/api/user/records/${_id}?limit=${limit}`)
  }
  return request.get(`/user/records/${_id}`)
}

const get_user_records_range = (_id, _date) => request.get(`/user/records/${_id}/${_date}`)
/*
const get_user_records_range_v2 = (_id, _startDate, _endDate) =>
  request.get(`/user/recordsv2/${_id}/${_startDate}/${_endDate}`)*/

const get_user_records_range_v2 = (_id, _startDate, _endDate) =>
  axios.get(`https://api-admin.sparkletimekeeping.com/api/user/recordsv2/${_id}/${_startDate}/${_endDate}`)

const get_day_quote = () => request.get(`https://type.fit/api/quotes`)

const post_branch = (form_data) => request.post('/store/branch', form_data)

const post_store_distance = (_location) => request.post('/user/storedistance', _location)

const get_user_branch = (_id) => request.get(`/store/branch/${_id}`)

const patch_user_location = (_id, _data) => axios.patch(`https://api-admin.sparkletimekeeping.com/api/user/updateStore/${_id}`, _data)

const get_user_locationv1 = () => request.get(`https://ipapi.co/json/`)

const get_user_ip = () => request.get(`http://ipwho.is/`)

const get_user_company = () => request.get(`/users/company`)

const get_record_bystore = (data, fomattedDate) => request.post(`/store/records/${fomattedDate}`, data)

const update_user_password = (_id, _password) => request.get(`/user/updatePass/${_id}/${_password}`)

const get_user_locationv2 = () =>
  request.get(`https://ipapi.co/json/?key=HVywqXALKicFBIeVM2FDoZGwIvVQ3Ys0RtHTH4Cw67P6O2zoOY`)

const get_storyblok_version = () =>
  request.get(`https://api.storyblok.com/v1/cdn/spaces/announcement?version=published&token=cTyDJj4G8trQivtm2BFmpQtt`)

const get_storyblok_banners = (version) =>
  request.get(
    `https://api.storyblok.com/v1/cdn/stories/announcement?version=published&token=cTyDJj4G8trQivtm2BFmpQtt&cv=${version.data.space.version}`,
  )

const get_store_location = (company) => axios.get(`https://api-admin.sparkletimekeeping.com/api/store/location/${encodeURIComponent(company)}`)

const set_company_coc = (data) => request.post('/coc', data)

const get_company_coc = (company) => axios.post('https://api-admin.sparkletimekeeping.com/api/get/coc', company)

const post_schedule = (data) => axios.post('https://api-admin.sparkletimekeeping.com/api/schedule', data)

const post_schedule_admin = (data) => request.post('/v2/schedule', data)

const get_schedule = (_id) => request.get(`/schedule/${_id}`)

const get_all_schedule = (data) => request.post(`/all/schedule/`, data)

const get_verification_code = (data) => request.post(`/user/reset`, data)

const set_verification_code = (data) => request.post(`/user/verify`, data)

const set_new_password = (data) => request.post(`/user/newPass`, data)

const request_upload_url = (data) => request.post(`aws/upload`, data)

const post_store_announcement = (data) => request.post(`announcement/upload`, data)

const get_store_announcement = (data) => requestv2.post(`announcements`, data)

const edit_store_announcement = (data) => request.post(`edit/announcements`, data)

const toggle_announcement = (data) => request.post(`/toggle/announcement`, data)

const get_store_announcement_by_id = (id) => request.get(`announcements/${id}`)

const delete_store_announcement_by_id = (id) => request.get(`delete/announcements/${id}`)

const post_subscription = (data) => request.post(`/subscription`, data)

const get_subscription = (data) => request.post(`/get/subscription`, data)

const get_subscriptions = () => request.get(`/v2/subscriptions`)

const get_active_users = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/active`, data)

//const get_active_users = (data) => request.post(`/active`, data)

const generate_payslip = () => axios.get(`http://127.0.0.1:8000/api/payslip`)

const get_payslip_info = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/payslip-info`, data)

const get_timeAdjustment_otp = (data) => request.post(`/otp/time-adjustment`, data)

const post_timeAdjustment_otpVerify = (data) => request.post('/otp/verification', data)

const post_timeAdjustment_otpVerifyV2 = (data) => request.post('/v2/otp/verification', data)

const post_myschedule_otp = (data) => request.post('/otp/myschedule/send', data)

const get_videos_tutorial = (company) => request.get(`/store/videos/${company}`)

const post_videos_tutorial = (data) => request.post('/store/video', data)

const edit_video_tutorial = (id, data) => request.put(`/store/${id}`, data)

const delete_video_tutorial = (id) => request.delete(`/store/video/${id}`)

const get_checklist = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/checklist`, data)

const post_checklist = (data) => request.post(`/checklist/add`, data)

const delete_checklist = (data) => request.post(`/checklist/delete`, data)

const verify_password = (data) => request.post(`/verify/password`, data)

const verify_phone = (data) => request.post(`/verify/phone`, data)

const set_MPIN = (data) => request.post(`/set/MPIN`, data)

const send_MPIN_change_otp = (data) => request.post(`/auth/otp/mpin_change/send`, data)

const get_store = (id) => request.get(`/store/${id}`)

const get_store_qr = (id) => request.get(`/store/qr/${id}`)

const update_email = (data) => request.post(`/email/update`, data)

//const get_breaklist = (data) => request.post(`/breaklist`, data)
const get_breaklist = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/breaklist`, data)

const get_breaklistinfo = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/v2/breaklistinfo`, data)

const post_save_breaklist = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/save/breaklist`, data)

const get_store_breaklist = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/list/breaklist`, data)

/*const get_schedule_v2 = (data) => request.post(`schedule/v2`, data)*/
const get_schedule_v2 = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/schedule/v2`, data)

//const get_schedule_with_range = (data) => request.post(`/range/schedule`, data)
const get_schedule_with_range = (data) =>
  axios.post(`https://api-admin.sparkletimekeeping.com/api/range/schedule`, data)

const get_reports_for_breaklist = (data) =>
  axios.post(`https://api-admin.sparkletimekeeping.com/api/reports/breaklist`, data)

const delete_breaklist = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/delete/breaklist`, data)

/*const approve_breaklist = (data) => request.post(`/approve/breaklist`, data)*/
const approve_breaklist = (data) =>
  axios.post(`https://api-admin.sparkletimekeeping.com/api/v2/approve/breaklist`, data)

const updateBreaklistEmailSettings = (data) => request.patch('/user/settings/breaklist-email', data)

const approve_breaklist_otp = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/otp/breaklist`, data)

const get_user_records_range_v2_bystore = (data) => request.post(`report/store`, data)

const get_breaklist_pending = (data) => request.post(`list/breaklist/pending`, data)

const delete_schedule = (id) => request.get(`delete/schedule/${id}`)

const edit_schedule = (data) => request.post(`edit/schedule`, data)

const update_breaklist = (data) => request.post(`update/breaklist`, data)

const get_schedule_v2_bystore = (data) => request.post(`schedule/store`, data)

const get_user_by_store = (data) => request.post(`store/user`, data)

const get_new_store = () => request.get(`new/stores`)

const get_account_logs = (id) => request.get(`logs/${id}`)

const approve_new_store = (id) => request.get(`approve/store/${id}`)

const delete_group_store = (data) => request.post(`delete/store/group`, data)

const decline_new_store = (id) => request.get(`decline/store/${id}`)

const get_group_store = (id) => request.get(`group/store/${id}`)

const get_group_store_v2 = (id) => request.get(`v2/group/store/${id}`)

const post_group_store = (data) => request.post(`register/store`, data)

const get_user_bystore = (data) => request.post(`user/store`, data)

const get_archiveduser_bystore = (data) => request.post(`archiveduser/store`, data)

const edit_user_profile = (id, data) => request.post(`edit/profile/${id}`, data)

const edit_user_company = (id, data) => request.post(`edit/company/${id}`, data)

const get_active_fcm_token = async (id) => request.get(`/users/fcm/${id}`)

const get_specific_schedule = (id) => request.get(`/specific/schedule/${id}`)

const get_specific_schedule_with_date = (data) => request.post(`/specific/schedule/with/date`, data)

const get_specific_schedule_with_date_v2 = (data) => request.post(`/v2/specific/schedule/with/date`, data)

const post_schedule_employee = (data) => request.post(`/specific/schedule/employee`, data)

const patch_schedule_employee = (data) =>
  axios.patch(`https://api-admin.sparkletimekeeping.com/api/specific/schedule/employee`, data)

const update_schedule_remarks = (data) => request.patch('/specific/schedule/employee/remarks', data)

const get_payslip_v3 = (data) => axios.post('https://payroll-api.sparkletimekeeping.com/api/payroll/info/v3', data)

const get_groups = () => request.get('/groups')
// const get_groups = () => axios.get('https://api-admin.sparkletimekeeping.com/api/groups')

const delete_group = (id) => request.get(`/remove/group/${id}`)

const get_feedbacks = (id) => request.get(`/feedback`)

const download_feedbacks = async () => {
  try {
    const response = await axios.get('https://api-admin.sparkletimekeeping.com/api/feedback/download', {
      responseType: 'blob', // 👈 this is critical for binary/streamed responses
    })

    const blob = new Blob([response.data], {type: 'text/csv'})
    const url = window.URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = 'feedbacks.csv' // 👈 the filename you want
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.error('Download failed', err)
  }
}

const get_features = (data) => axios.post(`https://api-admin.sparkletimekeeping.com/api/check/feature`, data)

const submit_feedback = async (id, feedback) => {
  return await request.post(`/user/${id}/feedback`, feedback)
}

const subscribe_fcm_token = async (id, fcmToken, device) =>
  request.post(`/users/fcm/${id}/register`, {fcmToken, device})

const deleteDeviceFcmToken = async (id, fcmToken) => {
  return await request.delete(`/users/fcm/${id}/unregister`, {
    fcmToken: fcmToken,
  })
}

const change_password = async (data) => {
  try {
    const response = await axios.post('/api/users/change-password', data)
    return response
  } catch (error) {
    return error.response
  }
}

const edit_profile_pic = (data) => request.post(`/user/profile_pic/edit`, data)

const send_otp_for_mobile_change = (data) =>
  axios.post(`https://api-admin.sparkletimekeeping.com/api/user/otp/mobile/send`, data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json',
    },
  })

const verify_mobile_change_otp = (data) => request.post(`/user/otp/mobile/verify`, data)

const send_email_change_otps = (data) => request.post(`/user/otp/email/send`, data)

const verify_email_change_otp = (data) => request.post(`/user/otp/email/verify`, data)

const get_theme_song = (data) => request.post('/stores/theme-song/get', data)

const set_theme_song = (data) => request.post('/stores/theme-song/set', data)

const get_employee_handbook = (data) => request.post('/stores/employee-handbook/get', data)

const set_employee_handbook = (data) => request.post('/stores/employee-handbook/set', data)

const get_mission_vision = (data) => request.post('/stores/mission-vision/get', data)

const set_mission_vision = (data) => request.post('/stores/mission-vision/set', data)

const send_timein_otp = (data) =>
  axios.post('https://api-admin.sparkletimekeeping.com/api/v2/stores/time-in-qr/send-otp', data)

const generate_timein_otp = (data) =>
  axios.post('https://api-admin.sparkletimekeeping.com/api/stores/time-in-qr/generate-otp', data)

const generate_timein_qr = (data) =>
  axios.post('https://api-admin.sparkletimekeeping.com/api/v2/stores/time-in-qr/generate', data)

const get_timein_qr = (data) => request.post('/stores/time-in-qr/get', data)

const get_existing_internal_timein_otp = (data) => request.post('/stores/time-in-qr/get-existing-otp', data)

const check_breaklist = (data) => request.post('/check/breaklist', data)

const get_action_logs = (data) => axios.post('https://api-cronjob.sparkletimekeeping.com/api/action-logs', data)

const post_action_log = (data) => axios.post('https://api-cronjob.sparkletimekeeping.com/api/action-logs/create', data)

const post_holiday = (data) => request.post('/v2/holiday', data)

const get_holidays = () => request.get('/holidays')

const delete_holiday = (id) => request.get(`/delete/holiday/${id}`)


const get_training_materials = (data) => request.post('/training-materials/get', data)

const create_training_material = (data) => request.post('/training-materials/create', data)

const update_training_material = (id, data) => request.put(`/training-materials/update/${id}`, data)

const delete_training_material = (id) => request.delete(`/training-materials/delete/${id}`)

const get_training_material_by_id = (id) => request.get(`/training-materials/${id}`)

const rate_training_material = (id, data) => request.post(`/training-materials/${id}/rate`, data)

const complete_training_material = (id, data) => request.post(`/training-materials/${id}/complete`, data)

const rank_announcement = (data) => request.post(`/announcement/rank`, data)
const set_ui_version = (id, version) => request.patch(`/user/${id}/ui-version`, {version})

const _expObject = {
  get_user,
  get_user_status,
  check_user_archived,
  get_user_archived,
  get_users,
  get_users_archived,
  archive_user,
  restore_user,
  post_store_register,
  post_employee_register,
  patch_store_onboard,
  post_user_status,
  patch_user_onboard,
  get_user_records,
  get_user_records_range,
  get_day_quote,
  remove_user,
  post_branch,
  get_user_branch,
  post_user_workmate_status,
  get_user_records_range_v2,
  patch_user_location,
  get_user_locationv1,
  get_user_locationv2,
  get_user_ip,
  get_limited_users,
  get_users_bydate,
  create_new_password,
  validate_password,
  get_limited_usersV2,
  get_record_by_id,
  delete_record_by_id,
  delete_last_record_by_id,
  delete_demo_last_record,
  update_record_by_id,
  get_user_company,
  get_record_bystore,
  update_user_password,
  post_store_distance,
  get_store_location,
  get_storyblok_banners,
  get_storyblok_version,
  set_company_coc,
  get_company_coc,
  get_theme_song,
  set_theme_song,
  get_employee_handbook,
  set_employee_handbook,
  get_mission_vision,
  set_mission_vision,
  post_schedule,
  post_schedule_admin,
  get_schedule,
  get_all_schedule,
  set_verification_code,
  get_verification_code,
  set_new_password,
  request_upload_url,
  post_store_announcement,
  get_store_announcement,
  edit_store_announcement,
  get_store_announcement_by_id,
  delete_store_announcement_by_id,
  post_subscription,
  get_subscription,
  get_active_users,
  get_payslip_info,
  generate_payslip,
  get_timeAdjustment_otp,
  post_timeAdjustment_otpVerify,
  post_timeAdjustment_otpVerifyV2,
  get_videos_tutorial,
  post_videos_tutorial,
  edit_video_tutorial,
  delete_video_tutorial,
  get_checklist,
  post_checklist,
  delete_checklist,
  verify_password,
  get_store,
  get_store_qr,
  update_email,
  verify_phone,
  set_MPIN,
  send_MPIN_change_otp,
  get_breaklist,
  get_breaklistinfo,
  post_save_breaklist,
  get_store_breaklist,
  get_schedule_v2,
  get_schedule_with_range,
  get_reports_for_breaklist,
  delete_breaklist,
  approve_breaklist,
  delete_schedule,
  edit_schedule,
  get_active_fcm_token,
  subscribe_fcm_token,
  deleteDeviceFcmToken,
  get_new_store,
  approve_new_store,
  decline_new_store,
  edit_user_profile,
  edit_user_company,
  get_account_logs,
  get_group_store,
  get_group_store_v2,
  post_group_store,
  get_user_bystore,
  get_archiveduser_bystore,
  get_schedule_v2_bystore,
  get_user_records_range_v2_bystore,
  get_breaklist_pending,
  update_breaklist,
  delete_group_store,
  get_specific_schedule,
  get_specific_schedule_with_date,
  get_specific_schedule_with_date_v2,
  post_schedule_employee,
  change_password,
  get_user_by_store,
  post_myschedule_otp,
  edit_profile_pic,
  send_otp_for_mobile_change,
  verify_mobile_change_otp,
  send_email_change_otps,
  verify_email_change_otp,
  patch_schedule_employee,
  update_schedule_remarks,
  get_groups,
  get_subscriptions,
  delete_group,
  get_features,
  submit_feedback,
  send_timein_otp,
  generate_timein_qr,
  generate_timein_otp,
  get_timein_qr,
  get_existing_internal_timein_otp,
  get_limited_usersV3,
  get_limited_usersV4,
  check_breaklist,
  get_feedbacks,
  download_feedbacks,
  updateBreaklistEmailSettings,
  approve_breaklist_otp,
  get_action_logs,
  post_action_log,
  post_holiday,
  get_holidays,
  delete_holiday,
  get_training_materials,
  create_training_material,
  update_training_material,
  delete_training_material,
  get_training_material_by_id,
  rate_training_material,
  complete_training_material,
  toggle_announcement,
  rank_announcement,
  set_ui_version,
  get_payslip_v3
}

export default _expObject
